<template>
  <div>
    <!-- Section 1 -->
    <section ref="homepage" class="relative w-full">

        <Navbar
          v-on:goToSectionById="onGoToSectionById"
        ></Navbar>
    </section>

    <div style="margin-top:9em;">
      <StepsBar step="3"></StepsBar>
    </div>

    <div class="container mx-auto mt-10">

      <div class="flex flex-wrap bg-white mt-2">
        <div class="w-full lg:w-2/3 pt-4 pb-4 pl-5 pr-5">
          <div class="flex justify-between border-b pb-8">
            <h1 class="font-semibold text-xl uppercase">{{ $t('Cart') }}</h1>
          </div>

          <div v-for="(item, index) in cartItems" :key="index" class="mt-4 lg:mt-6 flex flex-col lg:flex-row justify-start items-start lg:items-center lg:space-x-6 xl:space-x-8 w-full">
              <div class="pb-4 lg:pb-8 w-full lg:w-40">
                  <img class="w-full hidden lg:block" :src="item.img" :alt="item.title" />
                  <img class="w-full lg:hidden" :src="item.img_medium" :alt="item.title" />
              </div>
              <div class="border-b border-gray-200 lg:flex-row flex-col flex justify-between items-start w-full pb-8 space-y-4 lg:space-y-0">
                  <div class="w-full flex flex-col justify-start items-start space-y-8">
                      <div class="text-base dark:text-white 2xl:text-xl font-semibold leading-6 text-gray-800">
                        <h3>{{ item.title.length >= 40 ?  item.title.substring(0, 40) + '...' : item.title }}</h3>
                        <p class="text-sm dark:text-white leading-none text-gray-500">
                          {{ $moment(item.selectedStartEndDateTime.startDate, 'DD-MM-YYYY hh:mm:ss').format('DD-MM-YYYY') }} {{ $moment(item.selectedStartEndDateTime.startTime, 'DD-MM-YYYY hh:mm:ss').format('HH:mm') }}
                          / {{ $moment(item.selectedStartEndDateTime.endDate, 'DD-MM-YYYY hh:mm:ss').format('DD-MM-YYYY') }} {{ $moment(item.selectedStartEndDateTime.endTime, 'DD-MM-YYYY hh:mm:ss').format('HH:mm') }}
                        </p>
                      </div>
                      <div class="flex justify-start items-start flex-col space-y-2">
                        <div v-if="item.allOptions.length>0">
                          <!-- <h6 class="text-base dark:text-white font-semibold text-gray-800 pb-1">Option:</h6> -->
                          <p
                            v-for="(productOption, index) in item.allOptions" :key="index"
                            class="text-sm dark:text-white leading-none text-gray-600">
                              <span v-if="productOption.quantityRequested">
                                <b>{{ productOption.quantityRequested }}</b> <small>x</small> {{ productOption.title }} <b>{{ productOption.price  }} €</b>
                              </span>
                          </p>
                        </div>
                      </div>
                  </div>
                  <div class="flex justify-between space-x-8 items-start w-full">
                      <p class="text-base dark:text-white xl:text-lg leading-6">{{ item.product_price }} €</p>
                      <p class="text-base dark:text-white xl:text-lg leading-6 text-gray-800">{{ item.quantityRequested }}</p>
                      <p class="text-base dark:text-white xl:text-lg font-semibold leading-6 text-gray-800">{{ item.total }} €</p>
                  </div>
              </div>
          </div>

          <router-link :to="{ name: 'reservation-client-login', params: { slug: $route.params.slug }}" class="flex font-semibold text-primary hover:text-gray-500 text-sm mt-10" rel="noopener noreferrer">
            <svg class="fill-current mr-2 text-primary w-4" viewBox="0 0 448 512"><path d="M134.059 296H436c6.627 0 12-5.373 12-12v-56c0-6.627-5.373-12-12-12H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.569 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296z"/></svg>
            {{ $t('ContinueShopping') }}
          </router-link>
        </div>

        <div id="summary" class="w-full lg:w-1/3 pt-4 pb-4 pl-5 pr-5 bg-gray-50">
          <div class="flex justify-between border-b pb-8">
            <h1 class="font-semibold text-xl uppercase">Récapitulatif de la commande</h1>
          </div>
          <div class="flex justify-between mt-10 mb-5">
            <span class="font-semibold text-sm uppercase">Article(s) {{ cartItems.length }}</span>
            <span class="font-semibold text-sm">{{ total }} €</span>
          </div>
          <!-- <div>
            <label class="font-medium inline-block mb-3 text-sm uppercase">Shipping</label>
            <select class="block p-2 text-gray-600 w-full text-sm">
              <option>Standard shipping - $10.00</option>
            </select>
          </div> -->

          <div class="mt-4 py-2">
            <div class="flex mb-3">
              <div class="flex w-full">
                  <div class="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center"></div>
                    <vs-textarea
                      counter="200"
                      class="-ml-10 pr-3 py-2 rounded-lg border-2 border-gray-200 outline-none focus:border-gray-500"
                      :label="CommentText"
                      :placeholder="$t('CommentHere')"
                      :counter-danger.sync="counterDanger"
                      v-model="comment"
                    />
                </div>
            </div>
          </div>

          <div class="py-2">
            <div class="flex mb-3">
              <div class="flex">
                  <div class="w-10 z-10 pl-1 text-center pointer-events-none flex items-center justify-center"><i class="mdi mdi-code-string text-gray-400 text-lg"></i></div>
                  <input
                      class="w-full -ml-10 pl-10 pr-3 py-2 rounded-lg border-2 border-gray-200 outline-none focus:border-gray-500"
                      name="firstname"
                      type="text"
                      v-model="coupon"
                      placeholder="Saisir votre coupon"
                      autocomplete="off"
                  >
                </div>
            </div>
            
            <button @click="submiltApplyCoupon()" class="bg-gray-800 hover:opacity-75 rounded-full px-5 py-2 text-sm text-white uppercase">{{ $t('Apply') }}</button>
          </div>

          <!-- Sélecteur de type de paiement -->
          <div class="mt-4 mb-4 pb-4 border-b" v-if="cartItems.length > 0">
            <label class="block text-sm font-semibold text-gray-700 mb-3 uppercase">Type de paiement</label>
            <div class="d-flex" style="gap: 1.5rem;">
              <vs-radio v-model="paymentType" vs-value="acompte" class="mr-4">
                Acompte ({{ pourcentageAccompte }}%)
                <span class="text-gray-500 ml-1">({{ montantAcompte }} €)</span>
              </vs-radio>
              <vs-radio v-model="paymentType" vs-value="totalite" class="mr-4">
                Totalité
                <span class="text-gray-500 ml-1">({{ total }} €)</span>
              </vs-radio>
            </div>
          </div>

          <div class="mt-4" v-show="paymentReservation && !modeBorneIsActive">

            <!-- Monetico -->
            <div class="monetico_pay" v-if="defaultOnlinePaymentMethod == 'Monetico' || defaultOnlinePaymentMethod == 'monetico'" >

              <p class="mt-2 text-gray-500 text-justify" v-if="parseFloat(calculMontantToPay) > 0">
                Une fois que vous avez terminé votre sélection vous pouvez valider votre commande 
                et passer au paiement de celle-ci en cliquant sur le bouton <b>« Payer {{ calculMontantToPay + ' €' }} »</b>
              </p>

              <p class="mt-2 text-gray-500 text-justify" v-else>
                Le montant de votre commande est de 0 €. Vous pouvez valider votre commande en cliquant sur le bouton <b>« Confirmer »</b>
              </p>

              <span id="redirect_pay_monetico"></span>
                
              <div class="mt-8">
                <div class="flex font-semibold justify-between py-3 text-sm border-t">
                  <span class="uppercase">{{ paymentLabel }}</span>
                  <span>{{ calculMontantToPay + ' €' }}</span>
                </div>

                <div v-if="paymentType === 'acompte'" class="flex font-semibold justify-between py-3 text-base border-t mb-3">
                  <span class="uppercase">Total</span>
                  <span>{{ total }} €</span>
                </div>
                <div v-else class="mb-3"></div>

                <TermsConditionCheckbox
                  v-on:termsConditionAcceptedEvent="termsConditionAcceptedEmit"
                  v-on:termsConditionShowPopupEvent="termsConditionShowPopupEmit"
                />

                <vs-button
                  @click="payWithMonetico()"
                  :disabled="submitBtnPayIsActive"
                  class="w-full flex justify-center rounded-full p-3 mt-4 hover:opacity-75 tracking-wide font-semibold shadow-lg cursor-pointer transition ease-in duration-500"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" class="inline h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  {{ parseFloat(calculMontantToPay) > 0 ? 'Payer ' + calculMontantToPay + ' €' : 'Confirmer' }}
                </vs-button>
              </div>
            </div>

            <!-- Paypal -->
            <div v-show="defaultOnlinePaymentMethod == 'Paypal' || defaultOnlinePaymentMethod == 'paypal'">

              <div class="mt-8">
                <div class="flex font-semibold justify-between py-3 text-sm border-t">
                  <span class="uppercase">{{ paymentLabel }}</span>
                  <span>{{ calculMontantToPay + ' €' }}</span>
                </div>

                <div v-if="paymentType === 'acompte'" class="flex font-semibold justify-between py-3 text-base border-t">
                  <span class="uppercase">Total</span>
                  <span>{{ total }} €</span>
                </div>

                <TermsConditionCheckbox
                  v-on:termsConditionAcceptedEvent="termsConditionAcceptedEmit"
                  v-on:termsConditionShowPopupEvent="termsConditionShowPopupEmit"
                />
                                
                <!-- Show PayPal button only if amount > 0 -->
                <div class="w-full flex justify-center mt-3" v-show="!submitBtnPayIsActive && parseFloat(calculMontantToPay) > 0">
                  <span class="w-full" id="paypal-button" ref="paypal_button"></span>
                </div>

                <!-- Show Confirm button if amount is 0 -->
                <vs-button
                  v-if="parseFloat(calculMontantToPay) === 0"
                  @click="payHorsLigne()"
                  :disabled="submitBtnPayIsActive"
                  class="w-full flex justify-center rounded-full p-3 mt-3 hover:opacity-75 tracking-wide font-semibold shadow-lg cursor-pointer transition ease-in duration-500"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" class="inline h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  Confirmer
                </vs-button>
              </div>
            </div>
            
            <!-- Stripe -->
            <div v-if="defaultOnlinePaymentMethod == 'Stripe' || defaultOnlinePaymentMethod == 'stripe'">
              <PaymentStripeCheckout
                v-on:payWithStripeCheckoutEvent="payWithStripeCheckoutEmit"
                v-on:termsConditionAcceptedEventStripe="termsConditionAcceptedEmit"
                v-on:termsConditionShowPopupEventStripe="termsConditionShowPopupEmit"
                :acompte="calculMontantToPay"
                :total="total"
                :paymentType="paymentType"
              ></PaymentStripeCheckout>
            </div>
          </div>

          <div v-if="!paymentReservation || modeBorneIsActive">
            
            <p class="mt-2 text-gray-500 text-justify">
              Le paiement total et la caution se feront sur place le jour de l’arrivée
            </p>
                
            <div class="mt-8">
              <div class="flex font-semibold justify-between py-3 text-sm border-t">
                <span class="uppercase">{{ paymentType === 'totalite' ? 'Montant à payer' : 'Acompte' }}</span>
                <span>{{ calculMontantToPay + ' €' }}</span>
              </div>

              <div v-if="paymentType === 'acompte'" class="flex font-semibold justify-between py-3 text-base border-t">
                <span class="uppercase">Total</span>
                <span>{{ total }} €</span>
              </div>

              <TermsConditionCheckbox
                v-on:termsConditionAcceptedEvent="termsConditionAcceptedEmit"
                v-on:termsConditionShowPopupEvent="termsConditionShowPopupEmit"
              />

              <vs-button
                @click="payHorsLigne()"
                :disabled="submitBtnPayIsActive"
                class="w-full flex justify-center rounded-full p-3 mt-3 hover:opacity-75 tracking-wide font-semibold shadow-lg cursor-pointer transition ease-in duration-500"
              >
                <svg xmlns="http://www.w3.org/2000/svg" class="inline h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Confirmer
              </vs-button>
            </div>
          </div>         

        </div>
      </div>
    </div>

    <Footer class="mt-10"></Footer>
    
    <vs-popup background-color="rgba(255,255,255,.6)" title="Conditions Générales de Location" :active.sync="showTermsAndConditionsPopup">
      <span class="justify-between py-3" v-html="termsAndConditionsText"></span>
    </vs-popup>
  </div>
</template>

<script>

const StepsBar = () => import("@/views/welcome-page/StepsBar.vue");
const Navbar = () => import("@/views/welcome-page/Navbar.vue");
const Footer = () => import("@/views/welcome-page/Footer.vue");
const PaymentStripeCheckout = () => import("@/views/welcome-page/reservation/PaymentStripeCheckout.vue");
const TermsConditionCheckbox = () => import("@/views/welcome-page/reservation/TermsConditionCheckbox.vue");

import moment from 'moment';
import axios from '@/axios.js'
import { mapState, mapGetters } from 'vuex'
export default {
  name: "ReservationPayment",
  data () {
    return {
      paymentMethodsList: null,
      counterDanger: false,
      isTermsConditionAccepted: false,
      showTermsAndConditionsPopup: false,
      comment: "",
      coupon: "",
      paymentType: 'acompte', // 'acompte' ou 'totalite'
    }
  },
  components: {
    StepsBar,
    Navbar,
    Footer,
    PaymentStripeCheckout,
    TermsConditionCheckbox
  },
  computed: {
    selectedStartEndDateTime () {
      return this.$store.state.eCommerce.selectedStartEndDateTime.slice()[0]
    },
    cartItems () {
      return this.$store.state.eCommerce.cartItems
    },
    currentClientId () {
      return this.$store.getters['getActiveClientForCurrentCompany'] ? this.$store.getters['getActiveClientForCurrentCompany'].id : ''
    },
    currentClientName () {
      return this.$store.getters['getActiveClientForCurrentCompany'] ? this.$store.getters['getActiveClientForCurrentCompany'].nom : ''
    },
    currentClientLastname () {
      return this.$store.getters['getActiveClientForCurrentCompany'] ? this.$store.getters['getActiveClientForCurrentCompany'].prenom : ''
    },
    currentClientEmail () {
      return this.$store.getters['getActiveClientForCurrentCompany'] ? this.$store.getters['getActiveClientForCurrentCompany'].email : ''
    },
    currentClientAddress () {
      return this.$store.getters['getActiveClientForCurrentCompany'] ? this.$store.getters['getActiveClientForCurrentCompany'].address : ''
    },
    ...mapGetters({
      total: "eCommerce/getCartTotal"
    }),
    ...mapState({
      applyCouponResponse: state => state.eCommerce.applyCouponResponse,
    }),
    pourcentageAccompte(){
     return this.$store.state.moduleSetting.customerSetting && this.$store.state.moduleSetting.customerSetting.config ? this.$store.state.moduleSetting.customerSetting.config.pourcentageAccompte : "10"
    },
    CommentText() {
      const key = this.$store.state.moduleSetting.customerSetting && 
                  this.$store.state.moduleSetting.customerSetting.apiKey === "livraison" 
                  ? "DeliveryAddress" 
                  : "Comment";
      return this.$t(key);
    },
    paymentReservation(){
      return this.$store.state.moduleSetting.customerSetting && this.$store.state.moduleSetting.customerSetting.config ? this.$store.state.moduleSetting.customerSetting.config.payment_reservation : false
    },
    defaultOnlinePaymentMethod(){
      return this.$store.state.moduleSetting.customerSetting && this.$store.state.moduleSetting.customerSetting.config ? this.$store.state.moduleSetting.customerSetting.config.defaultOnlinePaymentMethod : null
    },
    termsAndConditionsText(){
      return this.$store.state.moduleSetting.customerSetting && this.$store.state.moduleSetting.customerSetting.config ? this.$store.state.moduleSetting.customerSetting.config.description_article : ''
    },
    submitBtnPayIsActive() {
      return this.cartItems.length==0||!this.isTermsConditionAccepted?true:false
    },
    modeBorneIsActive() {
      return localStorage.getItem('modeBorneIsActive') ? true : false
    },
    calculMontantToPay()
    {
      const totalNum = parseFloat(this.total) || 0;
      
      // Si l'utilisateur choisit de payer la totalité
      if (this.paymentType === 'totalite') {
        return totalNum.toFixed(2)
      }
      
      // Sinon, calculer l'acompte (comportement par défaut)
      if (typeof this.pourcentageAccompte == 'undefined' && this.pourcentageAccompte == null) {
        return totalNum.toFixed(2)
      }
      const pourcentage = parseFloat(this.pourcentageAccompte) || 0;
      return (totalNum * (pourcentage / 100)).toFixed(2)
    },
    montantAcompte() {
      const totalNum = parseFloat(this.total) || 0;
      
      // Calcul du montant d'acompte pour l'affichage
      if (typeof this.pourcentageAccompte == 'undefined' && this.pourcentageAccompte == null) {
        return totalNum.toFixed(2)
      }
      const pourcentage = parseFloat(this.pourcentageAccompte) || 0;
      return (totalNum * (pourcentage / 100)).toFixed(2)
    },
    paymentLabel() {
      // Libellé à afficher selon le type de paiement
      return this.paymentType === 'totalite' ? 'Montant à payer' : 'Acompte'
    },
    calculeOldTotal() {
      const totalNum = parseFloat(this.total) || 0;
      
      // calcule pourcentage inverser
      if(this.applyCouponResponse != null && this.applyCouponResponse.type_coupon == 'pourcentage') {
        const value = parseFloat(this.applyCouponResponse.value) || 0;
        return (totalNum * (100/(100-value))).toFixed(2)
      }
      
      if(this.applyCouponResponse != null && this.applyCouponResponse.type_coupon == 'montant') {
        const value = parseFloat(this.applyCouponResponse.value) || 0;
        return (totalNum + value).toFixed(2)
      }
      return 0
    },
    calculeOldTotalText() {
      return this.calculeOldTotal+' €'
    }
  },
  methods: {
    async fetchPaymentMethodList() {
      this.$vs.loading()

      await this.$store.dispatch('paymentMethodManagement/fetchPaymentMethods')
      .then(res => {
        this.paymentMethodsList = res.data
        console.log('paymentMethodsList', this.paymentMethodsList)
        this.$vs.loading.close()
      })
      .catch(err => { 
        console.error(err)
        this.$vs.loading.close()
      })
    },
    removeItemFromCart (index, item) {
      if(typeof(item.productsheetIsExis) == 'undefined' && item.productsheetIsExist == true) {
        this.acceptAlert()
        return
      }

      const data = {
        index,
        item
      }
      this.$store.dispatch('eCommerce/removeItemInCart', data)
    },
    payHorsLigne() {
      this.callSubmitReservation(this.calculMontantToPay, this.comment)
    },
    payWithMonetico() {
      // Check if amount is 0€, skip payment provider
      if (parseFloat(this.calculMontantToPay) === 0) {
        this.callSubmitReservation(this.calculMontantToPay, this.comment)
        return
      }
      this.callSubmitReservationAndPayWithMonetico(this.calculMontantToPay, this.comment)
    },
    payWithStripeCheckoutEmit(payloadStripe) {
      // Check if amount is 0€, skip payment provider
      if (parseFloat(this.calculMontantToPay) === 0) {
        this.callSubmitReservation(this.calculMontantToPay, this.comment)
        return
      }
      this.submitReservationStripeCheckout(this.calculMontantToPay, this.comment, payloadStripe);
    },
    termsConditionAcceptedEmit(payload) {
      this.isTermsConditionAccepted = payload
    },
    termsConditionShowPopupEmit() {
      this.showTermsAndConditionsPopup = true
    },
    checkSelectedPaymentMethod() {

      if (this.paymentMethodsList != null) {
        this.paymentMethodsList.forEach(element => {
          if (this.defaultOnlinePaymentMethod == element.id) {
            console.log('element', element)
            return true
          } 
        });
      }
    },
    callSubmitReservation (montant = null, comment = '') {

      // const payload = this.setSubmitReservationData("Non réglé", montant, comment)
      const payload = {
        notify: this.$vs.notify,
        dialog: this.$vs.dialog,
        loading: this.$vs.loading,
        submitReservation: this.setSubmitReservationData("Non réglé", montant, comment)
      }

      console.log('payload', payload)
      
      this.$store.dispatch('eCommerce/submitReservation', payload)
    },
    async submitReservationStripeCheckout (montant = null, comment = '', payloadStripe) {

      const payload = {
        notify: this.$vs.notify,
        dialog: this.$vs.dialog,
        loading: this.$vs.loading,
        submitReservation: this.setSubmitReservationData("Stripe", montant, comment)
      }

      console.log('payload', payload)
      
      await this.$store.dispatch('eCommerce/submitReservationStripeCheckout', payload)
      .then(res => {
        console.log('res.data', res.data)

        // When the customer clicks on the button, redirect them to Checkout.
        const result = payloadStripe.redirectToCheckout({
          sessionId: res.data,
        });

        if (result.error) {
          // If `redirectToCheckout` fails due to a browser or network
          // error, display the localized error message to your customer
          // using `result.error.message`.
        }

      })
      .catch(err => { 
        console.error(err)
      })
    },
    callSubmitReservationAndPayWithMonetico (montant, comment = '') {
      this.$vs.loading()

      const submitReservation = this.setSubmitReservationData("Monetico", montant, comment)
      
      var _this = this;
      
      axios
        .post('/api/paiement/monetico', { data: submitReservation })
        .then(response => {
          _this.$vs.loading.close()
          if (response.status == 200) {
            console.log('data monetico=', response);
            document.getElementById('redirect_pay_monetico').innerHTML = '<form style="display:none;" method="post" action="' + response.data.action + '"><input type="hidden" name="version" id="version" value="' + response.data.version + '" /><input type="hidden" name="TPE" id="TPE" value="' + response.data.TPE + '" /><input type="hidden" name="date" id="date" value="' + response.data.date + '" /><input type="hidden" name="contexte_commande" id="contexte_commande" value="' + response.data.contexte_commande + '" /><input type="hidden" name="montant" id="montant" value="' + response.data.montant + '" /><input type="hidden" name="reference" id="reference" value="' + response.data.reference + '" /><input type="hidden" name="MAC" id="MAC" value="' + response.data.MAC + '" /><input type="hidden" name="url_retour_ok" id="url_retour_ok" value="' + response.data.url_retour_ok + '" /><input type="hidden" name="url_retour" id="url_retour" value="' + response.data.url_retour + '" /><input type="hidden" name="url_retour_err" id="url_retour_err" value="' + response.data.url_retour_err + '" /><input type="hidden" name="lgue" id="lgue" value="' + response.data.lgue + '" /><input type="hidden" name="societe" id="societe" value="' + response.data.societe + '" /><input type="hidden" name="texte-libre" id="texte-libre" value="' + response.data.texte_libre + '" /><input type="hidden" name="mail" id="mail" value="' + response.data.mail + '" /><input type="hidden" name="nbrech" id="nbrech" value="" /><input type="hidden" name="dateech1" id="dateech1" value="" /><input type="hidden" name="montantech1" id="montantech1" value="" /><input type="hidden" name="dateech2" id="dateech2" value="" /><input type="hidden" name="montantech2" id="montantech2" value="" /><input type="hidden" name="dateech3" id="dateech3" value="" /><input type="hidden" name="montantech3" id="montantech3" value="" /><input type="hidden" name="dateech4" id="dateech4" value="" /><input type="hidden" name="montantech4" id="montantech4" value="" /><input type="submit" id="redirbtn" /></form>';
            document.getElementById('redirbtn').click();
          }
        })
        .catch(function (error) {
          console.log(error);
          _this.$vs.loading.close()

          _this.$vs.notify({
            time: 8000,
            title: 'Error',
            text: "Votre tentative de paiement a échoué, veuillez réessayer ultérieurement.", // "Une erreur s'est produite veuillez réessayer ultérieurement.",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
            position:'top-right'
          })
        })
      ;

    },
    callSubmitReservationAndPayWithStripe(montant, comment = "", stripe_payment_id) {
      this.$vs.loading();

      const submitReservation = this.setSubmitReservationData("Stripe", montant, comment, stripe_payment_id);

      var _this = this;

      axios.post("/api/v4/paiement/stripe", { data: submitReservation })
      .then((res) => {
        _this.$vs.loading.close();
        if (res.status == 200) {
          _this.$store.commit("eCommerce/TOGGLE_LOADING_PAY_STRIPE", false);
          _this.clearCart()
          _this.$router.push({ path: `/confirm-order/${res.data.identifier}`, params: { slug: this.$route.params.slug } })
        }
      })
      .catch(function (error) {
        console.log(error);
        _this.$vs.loading.close();
        _this.$store.commit("eCommerce/TOGGLE_LOADING_PAY_STRIPE", false);

        _this.$vs.notify({
          time: 8000,
          title: "Error",
          text:"Votre tentative de paiement a échoué, veuillez réessayer ultérieurement.", // "Une erreur s'est produite veuillez réessayer ultérieurement.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "top-right",
        });
      });
    },
    setSubmitReservationData(payment_method = '', montant = null, comment = '', stripe_payment_id = "") {

      const selectedStartEndDateTime = {
        startDate: moment(this.selectedStartEndDateTime.startDate).format('YYYY-MM-DD'),
        endDate: moment(this.selectedStartEndDateTime.endDate).format('YYYY-MM-DD'),
        startTime: moment(this.selectedStartEndDateTime.startTime).format('HH:mm'),
        endTime: moment(this.selectedStartEndDateTime.endTime).format('HH:mm'),
      }

      console.log('selectedStartEndDateTime', selectedStartEndDateTime)


      this.$store.state.eCommerce.cartItems.forEach(element => {
        let selectedStartEndDateTime = {
          startDate: moment(element.selectedStartEndDateTime.startDate).format('YYYY-MM-DD'),
          endDate: moment(element.selectedStartEndDateTime.endDate).format('YYYY-MM-DD'),
          startTime: moment(element.selectedStartEndDateTime.startTime).format('HH:mm'),
          endTime: moment(element.selectedStartEndDateTime.endTime).format('HH:mm'),
        }
        element.selectedStartEndDateTime = selectedStartEndDateTime
      });

      return {
        host: "website",
        birthday: "0000-00-00",
        checked_method_of_paiement: "",
        client_address: this.currentClientAddress,
        client_email: this.currentClientEmail,
        client_firstname: this.currentClientName,
        client_lastname: this.currentClientLastname,
        couponcode: this.applyCouponResponse!=null ? this.applyCouponResponse.code : "",
        method_of_paiment: payment_method,
        paid: 0,
        gived_keys: 0,
        period: selectedStartEndDateTime,
        products: this.$store.state.eCommerce.cartItems,
        status: false,
        total: this.total,
        user_id: this.currentClientId,
        withoutDiscount: "",
        valueOfReservationId: "",
        montant: montant,
        comment: comment,
        payment_method: payment_method,
        stripe_payment_id: stripe_payment_id
      }
    },
    PaypalConfig() {

      var _this = this

      // Check if amount is 0€, don't render PayPal button
      if (parseFloat(this.calculMontantToPay) === 0) {
        return
      }

      window.paypal.Button.render({
        env: 'production', // 'sandbox' Or 'production'
        locale: this.$i18n.locale == 'fr' ? 'fr_FR' : 'en_US',
        style: {
          size: 'responsive',
          color: 'gold',
          shape: 'pill',
          label: 'checkout',
          tagline: 'true'
        },
        commit: true, // Optional: show a 'Pay Now' button in the checkout flow
                  
        payment: function(resolve, reject) { 
          // Set up the payment here, when the buyer clicks  on the button

          const paymentMethod = _this.defaultOnlinePaymentMethod
          const montant = _this.calculMontantToPay


          console.log('paymentMethod', paymentMethod)
    
          // Here call your own API server 
          return new Promise((resolve, reject) => {
            axios.post(`/api/v4/checkout-paypal`, {
              payment_method: paymentMethod,
              montant: montant,
              }, /*{ headers: { 'Authorization': 'Bearer ' + state.token } }*/
              )
              .then(res => {
                resolve(res.data.id)
              })
              .catch(error => {
                // console.log('error', error.response.data.errors)

                // if (error.response.status == 422){
                _this.validationErrors = error.response.data.errors;
                console.log('validationErrors', _this.validationErrors)
                // }

                reject(error)
              })
            })
          },

        onAuthorize: function(data, actions) {
          // Execute the payment here, when the buyer approves the transaction
          let paymentMethod = _this.defaultOnlinePaymentMethod
          const montant = _this.calculMontantToPay
          const comment = _this.comment
          const reservationData = _this.setSubmitReservationData("Paypal", montant, comment)

          return new Promise((resolve, reject) => {
            axios.post(`/api/v4/execute-paypal`, {
              payer_id: data.payerID,
              payment_id: data.paymentID,
              payment_method: paymentMethod,
              data: reservationData,
              montant: montant,
              }, /*{ headers: { 'Authorization': 'Bearer ' + state.token } }*/
              )
              .then(res => {
                const ref = res.data ? res.data.identifier : ''
                _this.clearCart()
                _this.$router.push({ path: `/confirm-order/${ref}`, params: { slug: this.$route.params.slug } })
                resolve(res)
              })
              .catch(error => {
                _this.validationErrors = error.response.data.errors;
                // console.log('validationErrors', _this.validationErrors)
                reject(error)
              })
            }
          )
        }
      }, '#paypal-button');

    },
    clearCart () {
      this.$store.dispatch('eCommerce/clearCart')
    },
    async submiltApplyCoupon() {
      if(this.coupon == '') return

      const payload = {
        params: {
         'couponCode': this.coupon
        },
        notify: this.$vs.notify,
        loading: this.$vs.loading
      }

      this.$vs.loading()

      await this.$store.dispatch('eCommerce/applyCoupon', payload)
      .then(res => {
        console.log('res', res)

        if(res.data.type_coupon == "montant" && res.data.value > this.total) {

          this.$store.dispatch('eCommerce/cancelApplyCoupon')

          this.$vs.notify({
            time:7000,
            title:'Alert',
            text:'Le montant du coupon est supérieur au total à payer.',
            color:'danger',
            iconPack: 'feather',
            icon:'icon-alert-circle',
            position:'top-right'
          })
        }

        this.$vs.loading.close()
      })
      .catch(err => { 
        console.error(err)
        this.$vs.loading.close()
      })
    },
    onGoToSectionById(val) {
      console.log('onProductListEmit', val)
      this.goTo(val)
    },
    goTo(refName) {
      var element = this.$refs[refName];
      if(typeof element == 'undefined') return
      var top = element.offsetTop;
      window.scrollTo(0, top);
      this.toggleMenu(false)
    }
  },
  created() {
    // this.fetchPaymentMethodList()
  },
  watch: {
    applyCouponResponse: function(){
      this.$forceUpdate();
    },
    paymentType: function(newVal, oldVal) {
      // Forcer la mise à jour quand le type de paiement change
      this.$forceUpdate();
    }
  },
  
  mounted() {
    this.$store.commit('eCommerce/UPDATE_WIZARD_STEPS_BAR', 3)

    const plugin = document.createElement("script");
    plugin.setAttribute(
      "src",
      "https://cdnjs.cloudflare.com/ajax/libs/alpinejs/2.8.0/alpine.js"
    );
    plugin.async = true;
    document.head.appendChild(plugin);
    if(this.defaultOnlinePaymentMethod == 'paypal'){
      var _this = this
      const paypal = document.createElement("script");
      paypal.setAttribute(
        "src",
        "https://www.paypalobjects.com/api/checkout.js"
      );
      paypal.async = true;
      paypal.addEventListener('load', _this.PaypalConfig);
      document.body.appendChild(paypal);
    }

  }
}

</script>


<style lang="css">

@import "https://unpkg.com/tailwindcss@2.0.2/dist/tailwind.min.css";


body{
  --tw-bg-opacity: 1;
  background-color: rgba(243,244,246,var(--tw-bg-opacity));
}

.shopping-cart{
  /* margin-top: 11em; */
}

.text-primary{
  --tw-text-opacity: 1;
  color: rgba(var(--vs-primary), 1)!important;
}

.bg-primary, .vs-button-primary.vs-button-filled, a.bg-primary:hover, a.bg-primary:focus, button.bg-primary:hover, button.bg-primary:focus{
    --tw-bg-opacity: 1;
    background-color: rgba(var(--vs-primary), 1)!important;
}

a.text-primary:hover, a.text-primary:focus {
  --tw-text-opacity: 0.75;
  color: rgba(var(--vs-primary), 1)!important;
}

</style>
